module.exports = {"sld:ColorMapEntry":[{"quantity":-999,"color":"#FFFFFF","label":"NO DATA"},{"quantity":0,"color":"#D7D7D7","label":"0"},{"quantity":0,"color":"#198CDB","label":"<=0.22"},{"quantity":0.001,"color":"#91E3AD","label":"0.22 - 0.7"},{"quantity":0.03,"color":"#DEFFB0","label":"0.7 - 1.43"},{"quantity":0.06,"color":"#FFE68C","label":"1.43 - 2.47"},{"quantity":0.1,"color":"#FF9982","label":"2.47 - 4.18"},{"quantity":12,"color":"#FF4D30","label":"4.18 - 6.99"}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/county_maize_wheat_rice_mme_1981_2016_lcr_70_rice.json
// module id = ilyw
// module chunks = 171